import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import TopBarLayout from "../../components/TopBarLayout";
import {
  apiContext,
  apiDict,
  replaceTempCdnUrl,
} from "../../context/api-v1/api";
import { getQueryStringArgs } from "../../utils/utils";
import { checkMobile } from "../../utils/utils";

import MiniArticleList from "./miniArticleList";

import {
  Box,
  Typography,
  Grid,
  Input,
  CssBaseline,
  Container,
  Button,
} from "@mui/material";
import { formatDateTime } from "../../utils/utils";
import store from "../../reducers/store";

import hljs from "highlight.js";
import "highlight.js/styles/a11y-dark.css";
// import "highlight.js/styles/default.css";

import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import IconButton from "@mui/material/IconButton";

export default function BlogContent() {
  const location = useLocation();
  return <BlogContentLayout location={location} />;
}

function BlogContentLayout({ location }) {
  const [blogData, setBlogData] = useState();
  // const [commentData, setCommentData] = useState();
  const [flushFlag, setFlushFlag] = useState(false);

  const navigate = useNavigate();
  const dataRef = useRef({ flag: true });
  const DownAndUpButtonRef = useRef();

  const user_id = localStorage.getItem("user_id");
  const is_phone = checkMobile();
  let blogUrl, blogID, page, search;
  if (location.state) {
    blogUrl = location.state.blogUrl;
    blogID = location.state.blogID;
    page = location.state.page;
    search = location.state.search;
  } else {
    const querys = getQueryStringArgs(); // 通过查询字符串获取信息, 方便页面使用锚点
    blogUrl = apiDict.article + `/${querys.blogID}`;
    blogID = parseInt(querys.blogID);
    page = querys.page;
    search = querys.search;
  }

  useEffect(() => {
    var unsubscribe = store.subscribe(() => {
      const data = store.getState().customization.currentArticleDatas;

      dataRef.current.flag = true;

      // 2024-11-25 21:42:31 不能直接使用 if 来判定字典是否存在数据, 空字典和空数组都判定为true
      if (Object.keys(data).length !== 0) {
        let url_ = `/blogs?blogID=${data.blogID}&page=${data.page}`;
        if (data.search) {
          url_ = `/blogs?blogID=${data.blogID}&page=${data.page}&search=${data.search}`;
        }
        navigate(url_, {
          state: {
            blogUrl: data.blogUrl,
            blogID: data.blogID,
            page: data.page,
            search: data.search,
            title: data.title,
          },
        });
        setFlushFlag(data);

        // oldData = data;
        window.scrollTo(0, 0); // 滚动到顶部
      }
    });

    return () => {
      unsubscribe(); // 注销监听
    };
  }, []);

  useEffect(() => {
    apiContext(blogUrl, "GET", setBlogData);
    // apiContext(apiDict.comment, "GET", setCommentData);
  }, [flushFlag]);

  useEffect(() => {
    // document.querySelectorAll("pre code").forEach((el) => {
    //   try {
    //     el.classList.add("hljs"); // 手动添加类名, 防止错漏代码css
    //     hljs.highlightElement(el);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // });

    if (!blogData) {
      return;
    }

    if (!dataRef.current.flag) {
      return;
    }
    dataRef.current.flag = false;
    document.title = blogData.title; // 文章标题

    window.editormd.markdownToCRenderer = function (
      toc,
      container,
      tocDropdown,
      startLevel
    ) {
      var html = "";
      var lastLevel = 0;
      var classPrefix = this.classPrefix;

      startLevel = startLevel || 1;

      for (var i = 0, len = toc.length; i < len; i++) {
        var text = toc[i].text;
        var level = toc[i].level;
        var slug = toc[i].slug;

        if (level < startLevel) {
          continue;
        }

        if (level > lastLevel) {
          html += "";
        } else if (level < lastLevel) {
          html += new Array(lastLevel - level + 2).join("</ul></li>");
        } else {
          html += "</ul></li>";
        }

        html +=
          '<li><a class="toc-level-' +
          level +
          '" href="#' +
          slug +
          '" level="' +
          level +
          '">' +
          text +
          "</a><ul>";
        lastLevel = level;
      }

      var tocContainer = container.find(".markdown-toc");

      if (
        tocContainer.length < 1 &&
        container.attr("previewContainer") === "false"
      ) {
        var tocHTML =
          '<div class="markdown-toc ' + classPrefix + 'markdown-toc"></div>';

        tocHTML = tocDropdown
          ? '<div class="' + classPrefix + 'toc-menu">' + tocHTML + "</div>"
          : tocHTML;

        container.html(tocHTML);

        tocContainer = container.find(".markdown-toc");
      }

      if (tocDropdown) {
        tocContainer.wrap(
          '<div class="' + classPrefix + 'toc-menu"></div><br/>'
        );
      }

      tocContainer
        .html('<ul class="markdown-toc-list"></ul>')
        .children(".markdown-toc-list")
        .html(html.replace(/\r?\n?\<ul\>\<\/ul\>/g, ""));

      // 2025-11-19 16:08:05 自定义的目录缩进
      // min 为最小标题折叠层级, max为最大折叠层级
      const wrapperToc = function (el, current, min = 1, max = 4) {
        if (current >= max) {
          return;
        }
        var titleList = el.querySelectorAll(":scope > li");

        for (const li of titleList) {
          const ul = li.querySelectorAll(":scope > ul")[0];
          if (ul == undefined) {
            continue;
          }
          if (ul.querySelectorAll(":scope > li").length === 0) {
            continue;
          }

          const c = current + 1;
          if (current <= min) {
            wrapperToc(ul, c);
          } else {
            // 1. 不显示再下层内容
            ul.style.display = "none";

            // 2. 添加展开标志
            const div_open = document.createElement("div");
            if (is_phone) {
              div_open.style.right = "15vw";
            } else {
              div_open.style.left = "8vw";
            }
            div_open.style.position = "absolute";
            div_open.style.top = "0";
            div_open.style.cursor = "pointer";

            // div_open.style.marginTop = "5px";

            const a = document.createElement("a");
            a.innerText = "▷";
            a.style.fontSize = "11px";
            a.style.fontWeight = 500;
            a.style.marginBottom = "2px";
            a.style.textAlign = "center";
            div_open.appendChild(a);
            li.appendChild(div_open);
            li.style.position = "relative";

            div_open.addEventListener("click", () => {
              const open_ = ul.style.display;
              const text_ = a.innerText;
              if (open_ == "none") {
                ul.style.display = "block";
              } else {
                ul.style.display = "none";
              }

              if (text_ == "▷") {
                a.innerText = "▼";
              } else {
                a.innerText = "▷";
              }
            });
            wrapperToc(ul, c);
          }
        }
      };

      const tocContainerList = tocContainer.find(".markdown-toc-list");
      if (tocContainerList.length != 0) {
        wrapperToc(tocContainerList[0], 1);
      }

      if (toc.length != 0) {
        tocContainerList.css({ marginTop: "15px", marginBottom: "15px" });
      }

      return tocContainer;
    };

    // md展示组件载入
    var tocContainer = document.getElementById("custom-toc-container");
    tocContainer.innerHTML = "";
    window.editormd.markdownToHTML("test-markdown-view", {
      // markdown: markdown, //+ "\r\n" + $("#append-test").text(),
      //htmlDecode      : true,       // 开启 HTML 标签解析，为了安全性，默认不开启
      // htmlDecode: "style,script,iframe", // you can filter tags decode
      //toc             : false,
      tocm: true, // Using [TOCM]
      tocContainer: "#custom-toc-container", // 自定义 ToC 容器层
      //gfm             : false,
      // tocDropdown     : true,
      // markdownSourceCode : true, // 是否保留 Markdown 源码，即是否删除保存源码的 Textarea 标签
      // emoji: true,
      // taskList: true,
      // tex: true, // 默认不解析
      // flowChart: true, // 默认不解析
      // sequenceDiagram: true, // 默认不解析
    });

    const mdView = document.getElementById("test-markdown-view");
    if (mdView) {
      if (is_phone) {
        mdView.style.padding = "30px";
        mdView.style.paddingTop = "10px";
        mdView.style.width = "calc(100% - 60px)";
        mdView.style.backgroundColor = "#f2f2f2";
      } else {
        mdView.style.padding = "50px";
        mdView.style.paddingTop = "70px";
        mdView.style.width = "calc(100% - 100px)";
      }

      mdView.querySelectorAll("img").forEach((img) => {
        img.src = replaceTempCdnUrl(img.src);
      });
    }
  }, [blogData]);

  useEffect(() => {
    if (!blogData) {
      return;
    }

    let scrollFunc;
    const toc = document.getElementsByClassName("toc")[0]; // 锚点跳转会触发scroll事件
    if (toc) {
      let tocScrollFlag = false; // 重复触发scroll无法解决
      toc.addEventListener("scroll", (e) => {
        e.stopPropagation();
      });
      toc.addEventListener("mouseenter", (e) => {
        e.stopPropagation();
        tocScrollFlag = true;
      });
      toc.addEventListener("mouseleave", (e) => {
        e.stopPropagation();
        tocScrollFlag = false;
      });

      const topBase = toc.offsetTop;
      scrollFunc = function (e) {
        if (is_phone) {
          // 移动端目录无需跟随响应
        } else {
          // e.stopPropagation();  // 影响编辑器翻页同步
          // 防止多次监听

          if (tocScrollFlag) {
            e.preventDefault();
            return; // 防止toc内部滚动传递
          }
          const windowTop = window.pageYOffset;
          const documentHeight = document.body.scrollHeight;
          const tocScrollHeight = toc.scrollHeight;
          const tocClientHeight = toc.clientHeight;
          const windowHeight = window.screen.height;

          if (windowTop >= topBase - 70) {
            // 需要减去 marginTop距离
            toc.style.position = "fixed";
            toc.style.top = "0";

            const documentScrollPercent =
              (windowTop - topBase) / (documentHeight - windowHeight); // 防止滑动速度过快
            const tocBoxScroll =
              (tocScrollHeight - tocClientHeight + 20) * documentScrollPercent; // 目录提前20px置底
            toc.scroll(1, tocBoxScroll);
            // console.log(tocBoxScroll); // bug

            DownAndUpButtonRef.current.style.display = "block"; // 2024-5-31 16:31:08 开关首页/底页按钮展示
            // console.log(DownAndUpButtonRef);
          } else {
            toc.style.position = "static";
            DownAndUpButtonRef.current.style.display = "none";
          }

          // console.log(
          //   topBase,
          //   toc.offsetTop,
          //   toc.offsetHeight,
          //   window.pageYOffset,
          //   document.body.scrollHeight,
          //   toc.scrollHeight,
          //   windowTop,
          //   windowHeight,
          //   windowTop / windowHeight,
          //   tocBoxScroll
          // );
        }
      };
      window.addEventListener("scroll", scrollFunc);
    }

    return () => {
      window.removeEventListener("scroll", scrollFunc);
    };
  }, [blogData]);

  function handleEditClick() {
    navigate("/blog/edit/", {
      state: {
        next: window.location.pathname + window.location.search,
        articleDatas: blogData,
      },
    });
  }

  function handleTocCtlClick(e) {
    const toc = document.getElementsByClassName("toc")[0];
    if (toc.style.display == "block") {
      toc.style.display = "none";
    } else {
      toc.style.display = "block";
    }

    if (e.target.innerText == "﹤") {
      e.target.innerText = "﹥";
    } else {
      e.target.innerText = "﹤";
    }
  }

  let DownAndUpButtonStyle = {
    position: "fixed",
    display: "none",
    bottom: "calc(15vh-70px)",
  };

  let tocStyle = {};
  if (blogData) {
    if (is_phone) {
      tocStyle = {
        // margin: "70px 2vw 0 5vw",
        borderRadius: "5px",
        // height: "50vh",
        maxHeight: "50vh",
        width: "60vw",
        position: "fixed",
        top: "35vh",
        right: "0",
        display: "none",
      };
    } else {
      tocStyle = {
        margin: "70px 2vw 0 5vw",
        borderRadius: "5px",
        maxHeight: "85vh",
        width: "13vw",
      };
    }
  }

  return (
    <>
      <TopBarLayout type={"blog"} />
      <Container
        maxWidth={false}
        sx={{
          marginTop: is_phone ? "30px" : "30px",
          padding: "0",
        }}
      >
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: is_phone ? "10vh" : "15vh",
              mb: "30px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: is_phone ? "100%" : "60%",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "1.2rem",
                  mb: "10px",
                  textAlign: "center",
                  width: "70%",
                }}
              >
                {blogData ? blogData.title : ""}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="body2"
                  sx={{ fontSize: is_phone ? "0.7rem" : "0.9rem" }}
                >
                  {blogData
                    ? formatDateTime(new Date(blogData.created_at))
                    : ""}
                </Typography>
                {user_id && blogData && user_id == blogData.author.id ? ( // 2025-09-05 10:00:59 id类型不同, 不使用 ===
                  <Typography
                    sx={{ cursor: "pointer", color: "green", ml: "5px" }}
                    onClick={handleEditClick}
                    variant="body2"
                  >
                    编辑
                  </Typography>
                ) : (
                  ""
                )}
              </Box>
            </Box>
          </Box>
          <Grid container>
            {is_phone ? (
              ""
            ) : (
              <Grid item xs={2.5}>
                <MiniArticleList id={blogID} page={page} search={search} />
              </Grid>
            )}
            <Grid item xs={is_phone ? 12 : 7} className="codeCotainer">
              <Box sx={{ marginBottom: "50px" }} className="codeCotainer_">
                <>
                  {/* {blogData ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: blogData.body_html }}
                    ></div>
                  ) : (
                    ""
                  )} */}
                  {blogData ? (
                    // key强制react重新加载元素
                    <div id="test-markdown-view" key={blogData.id}>
                      <textarea
                        style={{ display: "none" }}
                        defaultValue={blogData.body}
                      ></textarea>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              </Box>
            </Grid>
            {/* 无法根据是否有目录来进行目录栏渲染, 目录栏渲染需要时间,即读即渲时间不足 */}
            {is_phone ? (
              <Grid item xs={2.5}>
                <Box
                  ref={DownAndUpButtonRef}
                  className={"DownAndUpButton"}
                  style={{ position: "fixed", bottom: "2vh", right: "0" }}
                >
                  <div>
                    <IconButton
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    >
                      <PublishOutlinedIcon fontSize="small" />
                    </IconButton>
                  </div>
                  <div>
                    <IconButton
                      onClick={() =>
                        window.scrollTo({
                          top: document.body.scrollHeight,
                          behavior: "smooth",
                        })
                      }
                    >
                      <DownloadOutlinedIcon fontSize="small" />
                    </IconButton>
                  </div>
                </Box>

                {/* 2024-05-31 22:15:43 为了目录可手动开关, 将目录渲染分为两个容器, 原始容器(目录不可延展; 且为了一开始不展示改容器, 修改display为none), 新容器(目录修改为延展) */}

                <Box>
                  {/* 2024-10-16 15:15:27 增加移动端跳转栏开关控制 */}
                  <div
                    style={{
                      position: "fixed",
                      right: 0,
                      bottom: "45vh",
                      zIndex: "99",
                    }}
                    onClick={handleTocCtlClick}
                  >
                    <p style={{ fontSize: "30px", color: "rgb(0 0 0 / 54%)" }}>
                      ﹤
                    </p>
                  </div>
                  <div
                    id="custom-toc-container"
                    className="toc"
                    style={{ ...tocStyle }}
                  ></div>
                </Box>
              </Grid>
            ) : (
              <Grid item xs={2.5}>
                <Box
                  ref={DownAndUpButtonRef}
                  className={"DownAndUpButton"}
                  style={{ ...DownAndUpButtonStyle }}
                >
                  <div>
                    <IconButton
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    >
                      <PublishOutlinedIcon />
                    </IconButton>
                  </div>
                  <div>
                    <IconButton
                      onClick={() =>
                        window.scrollTo({
                          top: document.body.scrollHeight,
                          behavior: "smooth",
                        })
                      }
                    >
                      <DownloadOutlinedIcon />
                    </IconButton>
                  </div>
                </Box>
                <div
                  id="custom-toc-container"
                  className="toc"
                  style={{ ...tocStyle }}
                ></div>
              </Grid>
            )}
          </Grid>
        </>
      </Container>
    </>
  );
}
